__webpack_require__.p = "https://assets.uniontownredevelopment.com/properties/";